import React from 'react';
import { Alert } from 'antd';

export interface VerdictBarProps {
  verdict: 'green' | 'yellow' | 'red' | null;
  headline?: string;
  subText?: string;
}

/** Top-of-form overall verdict. Returns null when verdict is null (form just started). */
export const VerdictBar: React.FC<VerdictBarProps> = ({ verdict, headline, subText }) => {
  if (!verdict) return null;
  const type = verdict === 'green' ? 'success' : verdict === 'yellow' ? 'warning' : 'error';
  const defaultHeadline =
    verdict === 'green' ? 'ALL GOOD' : verdict === 'red' ? 'PROBLEM FOUND' : 'CHECK';
  return (
    <Alert
      type={type as any}
      showIcon
      message={<strong>{headline ?? defaultHeadline}</strong>}
      description={subText}
      style={{ marginBottom: 12 }}
    />
  );
};
